import type { RomMeta } from './romRepository';
import { getRomFileBlobs, romHasLocalData } from './romRepository';
import {
  AUTOSAVE_SLOT,
  getSaveRecord,
  listStates,
  sramKeyFor,
  isPsxMemcardSaveKey,
} from './saveRepository';
import { downloadBlob, downloadBytes, safeDownloadName } from './download';

/** ROM 本体（複数ファイルなら順に）をダウンロードする。 */
export async function downloadRomFiles(rom: RomMeta): Promise<number> {
  if (!romHasLocalData(rom)) {
    throw new Error('この端末に ROM 本体がありません');
  }
  const files = await getRomFileBlobs(rom.id);
  const names = Object.keys(files);
  if (names.length === 0) throw new Error('ROM ファイルが見つかりません');

  for (const name of names) {
    const blob = files[name]!;
    downloadBlob(safeDownloadName(name, rom.filename), blob);
    // 連続 download がブロックされないよう少し間を空ける
    await new Promise((r) => setTimeout(r, 250));
  }
  return names.length;
}

/** SRAM とセーブステートをダウンロードする。 */
export async function downloadSaveData(rom: RomMeta): Promise<number> {
  let count = 0;
  const base = safeDownloadName(rom.title, 'game');

  const sramKey = sramKeyFor(rom.system, rom.id);
  const sram = await getSaveRecord(sramKey);
  if (sram && sram.data.byteLength > 0) {
    const suffix = isPsxMemcardSaveKey(sramKey) ? 'memcard' : 'sram';
    downloadBytes(`${base}.${suffix}.bin`, sram.data);
    count++;
    await new Promise((r) => setTimeout(r, 250));
  }

  const states = await listStates(rom.id);
  for (const st of states) {
    if (st.slot === AUTOSAVE_SLOT) continue;
    downloadBytes(`${base}.state${st.slot + 1}.bin`, st.data);
    count++;
    await new Promise((r) => setTimeout(r, 250));
  }

  if (count === 0) throw new Error('ダウンロードできるセーブがありません');
  return count;
}
